import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { isEmpty } from '../../utils/obj-utils';

function FileActionsTable({
    files,
    noActionsToPerformText,
    orderTypeValues,
    onViewFileSummaryClick,
    showExpiryDate
}) {
    function handleViewFileSummaryClick(event, fileNumber) {
        event.preventDefault();
        onViewFileSummaryClick(fileNumber);
    }
    function displayFiles() {
        return files.map((file, index) => {
            const isLast = index + 1 === files.length;
            return <div
                key={_.uniqueId()}
                className={`flex-grid  ${isLast ? 'last' : ''}`}>
                <div className='col'>
                    <span className='header'>{formMessageConstants.file}</span>
                    <span>{file.fileNumber}</span>
                </div>
                {
                    showExpiryDate ?
                        <div className='col'>
                            <span className='header'>{formMessageConstants.expiryDate}</span>
                            <span>{file.expiryDateText}</span>
                        </div> :
                        <div className='col'></div>
                }
                <div className='col'>
                    <span className='header'>{formMessageConstants.actions}</span>
                    <a
                        className='dashboard-action'
                        onClick={(event) => { handleViewFileSummaryClick(event, file.fileNumber); }} >{orderTypeValues[file.orderTypeIndex]}
                    </a>
                </div>
            </div>;
        });
    }

    return (
        <div className='table'>
            {isEmpty(files) ?
                <div className='no-files'>
                    <p className='info'>{noActionsToPerformText}</p>
                </div> :
                <Fragment>
                    <div className='flex-grid table-header'>
                        <div className='col'>{formMessageConstants.file}</div>
                        {
                            showExpiryDate ?
                                <div className='col'>{formMessageConstants.expiryDate}</div> :
                                <div className='col'></div>
                        }
                        <div className='col'>{formMessageConstants.actions}</div>
                    </div>
                    {displayFiles()}
                </Fragment>
            }
        </div>
    );
}

FileActionsTable.propTypes = {
    files: PropTypes.array.isRequired,
    noActionsToPerformText: PropTypes.string.isRequired,
    orderTypeValues: PropTypes.object.isRequired,
    onViewFileSummaryClick: PropTypes.func.isRequired,
};

export default FileActionsTable;
